/**
 * Returns the entry with the highest numeric key from a saved-content map
 * (`savedBlog`, `savedSocialPost`, `savedEmail`, `savedTalkingPointContent`),
 * or `null` when the map is empty/missing.
 *
 * The maps are keyed by epoch-ms timestamps. Object keys are stored as
 * strings, so we parse back to numbers and drop anything non-finite as a
 * defensive guard against malformed Dato payloads. Returning `null` for
 * the empty case prevents `Math.max(...[])` from producing `-Infinity` and
 * corrupting downstream state.
 */
export function latestSavedEntry<T>(
  map: Record<number, T> | null | undefined,
): { id: number; entry: T } | null {
  if (!map) return null;
  const ids = Object.keys(map).map(Number).filter(Number.isFinite);
  if (ids.length === 0) return null;
  const id = Math.max(...ids);
  const entry = map[id];
  return entry ? { id, entry } : null;
}
